import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Curalate } from './curalate.namespace';

export function provideCuralate(options?: Partial<Curalate.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: Curalate.OPTIONS,
            useValue: options
        }
    ]);
}
